module.exports = __webpack_public_path__ + "img/7.b0135d45.jpg";